const CHECK_PREVIEW_ATTEMPTS_NUMBER = 7;
const CHECK_PREVIEW_PAUSE = 1000; // one second
const CHECKOUT_FLOW = 'checkout';
const PACKAGES_FLOW = 'packages';

module.exports = {
    CHECK_PREVIEW_ATTEMPTS_NUMBER,
    CHECK_PREVIEW_PAUSE,
    CHECKOUT_FLOW,
    PACKAGES_FLOW
};
